import {
  AuthState,
  IForgotPassword,
  ILogin,
  IRegister,
  IUserDataInterface,
  RetailRegister,
} from "../types";

export const defaultLoginForm: ILogin = {
  email: "",
  password: "",
};

export const defaultForgotPasswordForm: IForgotPassword = {
  email: "",
};

export const defaultRegisterForm: IRegister = {
  email: "",
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  mobileNumber: "",
  password: "",
  confirmPassword: "",
  streetAddress: "",
  prefectures: "",
  postCode: "",
  companyName: "",
  companyName_H: "",
  companyLocation: "",
  companyLocation_H: "",
  companyDepartmentName: "",
  companyDepartmentName_H: "",
  companyRepresentativeName: "",
  companyRepresentativeName_H: "",
  companyMobileNumber: "",
  companyFaxNumber: "",
};

// Retail register
export const defaultRetailRegister: RetailRegister = {
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  postalCode: "",
  prefecture: "",
  streetAddress: "",
  mobileNumber: "",
  email: "",
  password: "",
  confirmpassword: "",
  companyName: "",
  companyName_H: "",
  companyLocation: "",
  companyLocation_H: "",
  companyDepartmentName: "",
  companyDepartmentName_H: "",
  companyRepresentativeName: "",
  companyRepresentativeName_H: "",
  companyMobileNumber: "",
  companyFaxNumber: "",
};
export const defaultUserData: IUserDataInterface = {
  firstName: "",
  lastName: "",
  japaneseFirstName: "",
  japaneseLastName: "",
  profilePic: "",
  email: "",
  _id: "",
};

export const initialState: AuthState = {
  form: {
    ...defaultLoginForm,
  },
  userData: { ...defaultUserData },
  registerForm: { ...defaultRegisterForm },
  forgotPasswordForm: { ...defaultForgotPasswordForm },
  loading: false,
  token: "",
  isLogin: false,
  isToken: "",
  isPathname: "",
  togglePassword: false,
  toggleConfirmPassword: false,
  buttonLoading: false,
};
